// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_8954bb9","icon":"_d162390"};